import { render, staticRenderFns } from "./ActionHandler.vue?vue&type=template&id=98980478&"
import script from "./ActionHandler.vue?vue&type=script&lang=js&"
export * from "./ActionHandler.vue?vue&type=script&lang=js&"
import style0 from "./ActionHandler.vue?vue&type=style&index=0&id=98980478&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports